import api from "../axios";
import { RoamingApiStruct, RoamingCountryStruct } from "@/struct/RoaminStruct";

export const GetCountries = async (
  search = "" as string,
  isPopular = false
) => {
  return await api
    .get<RoamingApiStruct<RoamingCountryStruct[]>>(
      "/api/public/roaming/get-countries",
      {
        params: {
          name: search,
          ...(isPopular && { is_popular: isPopular }),
        },
      }
    )
    .then((res) => {
      if (res.data.status) return res.data.data;
      else throw res.data;
    })
    .catch((err) => {
      throw err;
    });
};
